import * as React from "react";

import { Expert } from "../../models/expert";
import { useConsultation } from "../../context/ConsultationContext";

import ExpertButtonUI from "./ExpertButtonUI";

interface Props {
  expert: Expert;
  className?: string;
  faClassName?: string;
}

const ExpertButton: React.FC<Props> = ({ expert, className, faClassName }) => {
  const { openConsultationModal } = useConsultation();

  return (
    <ExpertButtonUI
      expert={expert}
      onPhoneSelected={() => openConsultationModal("PHONE")(expert)}
      onVideoSelected={() => openConsultationModal("VIDEO")(expert)}
      onLivechatSelected={() => openConsultationModal("LIVECHAT")(expert)}
      onWrittenSelected={() => openConsultationModal("WRITTEN")(expert)}
      className={className}
      faClassName={faClassName}
    />
  );
};

export default ExpertButton;
